import React from 'react';

interface RoleBadgeProps {
  role: string;
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

const RoleBadge: React.FC<RoleBadgeProps> = ({ 
  role, 
  size = 'xs',
  className = '' 
}) => {
  const sizeClasses = {
    xs: 'text-xs px-2 py-0.5',
    sm: 'text-sm px-2.5 py-1',
    md: 'text-base px-3 py-1.5'
  };

  // Role-specific styling
  const getRoleClasses = (roleValue: string) => {
    const normalizedRole = roleValue.toLowerCase();
    
    switch (normalizedRole) {
      case 'leader':
      case 'owner':
        return 'bg-oro-surface-alt text-text-secondary border border-oro-error';
      case 'moderator':
        return 'bg-oro-surface-alt text-text-secondary border border-oro-info';
      case 'member':
      default:
        return 'bg-oro-surface-alt text-text-secondary border border-oro-border';
    }
  };

  return (
    <span 
      className={`
        rounded-full font-medium capitalize
        ${sizeClasses[size]}
        ${getRoleClasses(role)}
        ${className}
      `}
    >
      {role}
    </span>
  );
};

export default RoleBadge;